module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-card",
    class: {
      'rt-card-shadow': _vm.shadow
    }
  }, [_vm._v("\n  aaaaaaaa"), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e33ec6a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/card/rtCardV2.vue
// module id = 2226
// module chunks = 137